import { AccessLevelEnum } from '../types/permissionTypes';
import axios from 'axios';
import React from 'react';
import { Checkbox, Col } from '@digitools/honest-react';
import * as _ from 'lodash';
export async function updateEmployerUser(authHeader, requestBody) {
    return axios.patch(`/user-service/services/v1/users/employers`, requestBody, {
        headers: {
            Authorization: authHeader,
        },
    });
}
export function handleProductAllSelection(selectedOption, checkboxOptions, option, userInformation, customerConfig) {
    if (selectedOption.label === 'All') {
        if (selectedOption.checked === true) {
            checkboxOptions.forEach(opt => {
                opt.checked = true;
            });
            if (option === 'products') {
                userInformation.products.attributes = [];
                userInformation.products.accessLevel = AccessLevelEnum.FULL;
                getProducts(userInformation, customerConfig);
            }
            else if (option === 'crsSensitive') {
                userInformation.sensitiveData.CRS.attributes = [];
                userInformation.sensitiveData.CRS.accessLevel = AccessLevelEnum.FULL;
                getSensitiveData(userInformation, customerConfig);
            }
            else if (option === 'statusSensitive') {
                userInformation.sensitiveData.STATUS.attributes = [];
                userInformation.sensitiveData.STATUS.accessLevel = AccessLevelEnum.FULL;
                getStatusSensitiveData(userInformation, customerConfig);
            }
        }
        else {
            checkboxOptions.forEach(opt => {
                opt.checked = false;
            });
            if (option === 'products') {
                userInformation.products.attributes = [];
                userInformation.products.accessLevel = AccessLevelEnum.NO_ACCESS;
                getProducts(userInformation, customerConfig);
            }
            else if (option === 'crsSensitive') {
                userInformation.sensitiveData.CRS.attributes = [];
                userInformation.sensitiveData.CRS.accessLevel = AccessLevelEnum.NO_ACCESS;
                getSensitiveData(userInformation, customerConfig);
            }
            else if (option === 'statusSensitive') {
                userInformation.sensitiveData.STATUS.attributes = [];
                userInformation.sensitiveData.STATUS.accessLevel = AccessLevelEnum.NO_ACCESS;
                getStatusSensitiveData(userInformation, customerConfig);
            }
        }
    }
    else {
        if (option === 'products') {
            const selectedProducts = checkboxOptions.filter(prod => prod.checked === true).map(prod => prod.code);
            selectedProducts.length > 0
                ? selectedProducts.length === checkboxOptions.length
                    ? (userInformation.products.accessLevel = AccessLevelEnum.FULL)
                    : (userInformation.products.accessLevel = AccessLevelEnum.LIMITED)
                : (userInformation.products.accessLevel = AccessLevelEnum.NO_ACCESS);
            userInformation.products.attributes =
                userInformation.products.accessLevel === AccessLevelEnum.FULL ? [] : selectedProducts;
        }
        else if (option === 'crsSensitive') {
            const selectedSensitive = checkboxOptions
                .filter(crsSensitive => crsSensitive.checked === true)
                .map(crsSensitive => crsSensitive.code);
            selectedSensitive.length > 0
                ? selectedSensitive.length === checkboxOptions.length
                    ? (userInformation.sensitiveData.CRS.accessLevel = AccessLevelEnum.FULL)
                    : (userInformation.sensitiveData.CRS.accessLevel = AccessLevelEnum.LIMITED)
                : (userInformation.sensitiveData.CRS.accessLevel = AccessLevelEnum.NO_ACCESS);
            userInformation.sensitiveData.CRS.attributes =
                userInformation.sensitiveData.CRS.accessLevel === AccessLevelEnum.FULL ? [] : selectedSensitive;
        }
        else if (option === 'statusSensitive') {
            const selectedStatusSensitive = checkboxOptions
                .filter(statusSensitive => statusSensitive.checked === true)
                .map(statusSensitive => statusSensitive.code);
            selectedStatusSensitive.length > 0
                ? selectedStatusSensitive.length === checkboxOptions.length
                    ? (userInformation.sensitiveData.STATUS.accessLevel = AccessLevelEnum.FULL)
                    : (userInformation.sensitiveData.STATUS.accessLevel = AccessLevelEnum.LIMITED)
                : (userInformation.sensitiveData.STATUS.accessLevel = AccessLevelEnum.NO_ACCESS);
            userInformation.sensitiveData.STATUS.attributes =
                userInformation.sensitiveData.STATUS.accessLevel === AccessLevelEnum.FULL ? [] : selectedStatusSensitive;
        }
    }
}
export function getProducts(userInfo, customerConfig) {
    const accessLevelProducts = userInfo && userInfo.products ? userInfo.products.accessLevel : null;
    const validProductList = customerConfig.sharedProducts.map(configProduct => {
        return { checked: false, code: configProduct.productName, label: configProduct.productText };
    });
    if (accessLevelProducts === AccessLevelEnum.FULL) {
        validProductList.forEach(validProduct => {
            validProduct.checked = true;
        });
        return validProductList;
    }
    else {
        userInfo.products.attributes.forEach(selectedProduct => {
            validProductList.forEach(validProduct => {
                if (validProduct.code === selectedProduct) {
                    validProduct.checked = true;
                }
            });
        });
        return validProductList;
    }
}
export function getSensitiveData(userInfo, customerConfig) {
    const crsSensitiveAccessLevel = userInfo && userInfo.sensitiveData && userInfo.sensitiveData.CRS ? userInfo.sensitiveData.CRS.accessLevel : null;
    const validSharedFieldsList = customerConfig.sharedFields
        .filter(fields => fields.application === 'CRS' || fields.application === 'Both')
        .map(configField => {
        return { checked: false, code: configField.fieldText, label: configField.adminFieldText };
    });
    if (crsSensitiveAccessLevel === AccessLevelEnum.FULL) {
        validSharedFieldsList.forEach(validProduct => {
            validProduct.checked = true;
        });
        return validSharedFieldsList;
    }
    else {
        userInfo.sensitiveData.CRS.attributes.forEach(selectedField => {
            validSharedFieldsList.forEach(validSensitiveInfo => {
                if (validSensitiveInfo.code === selectedField) {
                    validSensitiveInfo.checked = true;
                }
            });
        });
        return validSharedFieldsList;
    }
}
export function getStatusSensitiveData(userInfo, customerConfig) {
    const statusSensitiveAccessLevel = userInfo && userInfo.sensitiveData && userInfo.sensitiveData.STATUS
        ? userInfo.sensitiveData.STATUS.accessLevel
        : AccessLevelEnum.NO_ACCESS;
    const validSharedFieldsList = customerConfig.sharedFields
        .filter(fields => fields.application === 'Status' || fields.application === 'Both')
        .map(configField => {
        return { checked: false, code: configField.fieldText, label: configField.adminFieldText };
    });
    if (statusSensitiveAccessLevel === AccessLevelEnum.FULL) {
        validSharedFieldsList.forEach(validProduct => {
            validProduct.checked = true;
        });
        return validSharedFieldsList;
    }
    else {
        userInfo.sensitiveData.STATUS.attributes.forEach(selectedField => {
            validSharedFieldsList.forEach(validSensitiveInfo => {
                if (validSensitiveInfo.code === selectedField) {
                    validSensitiveInfo.checked = true;
                }
            });
        });
        return validSharedFieldsList;
    }
}
export function setUserPermissionState(userInformation) {
    const user = userInformation;
    user.customerReportingSolution = false;
    user.subsidiariesAndLocations = AccessLevelEnum.NO_ACCESS;
    user.viewCorrespondence = false;
    user.viewStatus = false;
    user.viewPayments = false;
    user.viewClaimNotes = false;
    user.viewLeaveNotes = false;
    user.viewEmployeeDetails = false;
    user.viewAsCorrespondence = false;
    user.viewBasicAsRequest = false;
    user.viewFullAsRequest = false;
    user.asNotes = false;
    user.products.accessLevel = AccessLevelEnum.NO_ACCESS;
    user.products.attributes = [];
    if (user.sensitiveData.CRS !== undefined) {
        user.sensitiveData.CRS.accessLevel = AccessLevelEnum.NO_ACCESS;
        user.sensitiveData.CRS.attributes = [];
    }
    if (user.sensitiveData.STATUS !== undefined) {
        user.sensitiveData.STATUS.accessLevel = AccessLevelEnum.NO_ACCESS;
        user.sensitiveData.STATUS.attributes = [];
    }
}
/**
 * Deletes the granular crs-service subsidiaries/locations selection list for a user.
 * Used when the access level lands on FULL or NO_ACCESS, where no stored subset should remain.
 */
export async function clearEmployerSubsLocs(authHeader, userId) {
    return axios.delete(`/crs-service/er-admin/subs-locs/${userId}`, {
        headers: {
            Authorization: authHeader,
        },
    });
}
/**
 * Determines whether every MLP permission the customer actually has is at its maximum value.
 * Only capabilities the customer/user is entitled to are considered - capabilities the customer
 * does not have are excluded from the comparison rather than required to be true. Drives the
 * label of the All Permissions Control ("Clear All Permissions" when maxed, "Enable All Permissions" otherwise).
 */
export function isAllPermissionsMaxed(userInfo, customerConfig, permissions) {
    const statusER = permissions?.permission?.statusER;
    const claimLeave = statusER?.claimLeaveStatus;
    const accommodation = statusER?.viewAccommodationStatus;
    const hasCrs = !!permissions?.permission?.crsER;
    const checks = [];
    // Subsidiaries/Locations - always present on the form
    checks.push(userInfo.subsidiariesAndLocations === AccessLevelEnum.FULL);
    // Products - only when the customer config exposes products
    if (customerConfig.sharedProducts.length > 0) {
        checks.push(userInfo.products?.accessLevel === AccessLevelEnum.FULL);
    }
    // CRS "Create My Report" + CRS sensitive data
    if (hasCrs) {
        checks.push(userInfo.customerReportingSolution === true);
        const crsFields = customerConfig.sharedFields.filter(f => f.application === 'CRS' || f.application === 'Both');
        if (crsFields.length > 0) {
            checks.push(userInfo.sensitiveData?.CRS?.accessLevel === AccessLevelEnum.FULL);
        }
    }
    // View Status + its sub-flags + Status sensitive data
    if (statusER) {
        checks.push(userInfo.viewStatus === true);
        if (claimLeave?.viewCorrespondence)
            checks.push(userInfo.viewCorrespondence === true);
        if (claimLeave?.viewPaymentInformation)
            checks.push(userInfo.viewPayments === true);
        if (claimLeave?.viewClaimNotes)
            checks.push(userInfo.viewClaimNotes === true);
        if (claimLeave?.viewLeaveNotes)
            checks.push(userInfo.viewLeaveNotes === true);
        if (claimLeave?.viewEmployeeDetails)
            checks.push(userInfo.viewEmployeeDetails === true);
        if (accommodation?.viewBasicAsRequest)
            checks.push(userInfo.viewBasicAsRequest === true);
        if (accommodation?.viewFullAsRequest)
            checks.push(userInfo.viewFullAsRequest === true);
        if (accommodation?.viewAsCorrespondence)
            checks.push(userInfo.viewAsCorrespondence === true);
        if (accommodation?.asNotes)
            checks.push(userInfo.asNotes === true);
        const statusFields = customerConfig.sharedFields.filter(f => f.application === 'Status' || f.application === 'Both');
        if (statusFields.length > 0) {
            checks.push(userInfo.sensitiveData?.STATUS?.accessLevel === AccessLevelEnum.FULL);
        }
    }
    return checks.every(Boolean);
}
/**
 * Inverse of setUserPermissionState - sets the user's permission model to the maximum values for
 * every capability the customer actually has. Capabilities the customer does not have are left false /
 * NO_ACCESS so the save payload never grants something the customer is not entitled to.
 */
export function setUserPermissionStateToFull(userInformation, customerConfig, permissions) {
    const user = userInformation;
    const statusER = permissions?.permission?.statusER;
    const claimLeave = statusER?.claimLeaveStatus;
    const accommodation = statusER?.viewAccommodationStatus;
    const hasCrs = !!permissions?.permission?.crsER;
    user.subsidiariesAndLocations = AccessLevelEnum.FULL;
    if (customerConfig.sharedProducts.length > 0) {
        user.products.accessLevel = AccessLevelEnum.FULL;
        user.products.attributes = [];
    }
    user.customerReportingSolution = hasCrs;
    if (user.sensitiveData.CRS !== undefined) {
        const crsFields = customerConfig.sharedFields.filter(f => f.application === 'CRS' || f.application === 'Both');
        if (hasCrs && crsFields.length > 0) {
            user.sensitiveData.CRS.accessLevel = AccessLevelEnum.FULL;
            user.sensitiveData.CRS.attributes = [];
        }
    }
    if (user.sensitiveData.STATUS !== undefined) {
        const statusFields = customerConfig.sharedFields.filter(f => f.application === 'Status' || f.application === 'Both');
        if (statusER && statusFields.length > 0) {
            user.sensitiveData.STATUS.accessLevel = AccessLevelEnum.FULL;
            user.sensitiveData.STATUS.attributes = [];
        }
    }
    user.viewStatus = !!statusER;
    user.viewCorrespondence = !!claimLeave?.viewCorrespondence;
    user.viewPayments = !!claimLeave?.viewPaymentInformation;
    user.viewClaimNotes = !!claimLeave?.viewClaimNotes;
    user.viewLeaveNotes = !!claimLeave?.viewLeaveNotes;
    user.viewEmployeeDetails = !!claimLeave?.viewEmployeeDetails;
    user.viewBasicAsRequest = !!accommodation?.viewBasicAsRequest;
    user.viewFullAsRequest = !!accommodation?.viewFullAsRequest;
    user.viewAsCorrespondence = !!accommodation?.viewAsCorrespondence;
    user.asNotes = !!accommodation?.asNotes;
}
export function checkBoxSelection(listOptions, name, enabled, userInfo, customerConfig) {
    const checkboxOptions = listOptions;
    const optionsArray = _.chunk(checkboxOptions, Math.ceil(checkboxOptions ? checkboxOptions.length / 3 : 2));
    const optionCheckboxRows = optionsArray.map((subOptions, indexRow) => {
        return (<Col lg={4} key={indexRow}>
        {subOptions.map((option, index) => {
                const onOptionChange = (event) => {
                    option.checked = event.currentTarget.checked;
                    handleProductAllSelection(option, checkboxOptions, name, userInfo, customerConfig);
                };
                return (<Col style={{ marginTop: '.3rem' }} key={name + 'col' + index}>
              {' '}
              <Checkbox key={option.code} field={option.code} disabled={!enabled} initialValue={option.checked} label={option.label} onChange={onOptionChange}/>
            </Col>);
            })}
      </Col>);
    });
    return optionCheckboxRows;
}
